import axios from "axios";
import { API_URL } from "../utils/constant";
import {
  ALERTS_FETCHED,
  CREATE_INTEGRATION,
  FETCHING_ALERTS,
  FETCH_INTEGRATION,
  ALERT_INTEGRATION
} from "./index";
import { toastr } from "react-redux-toastr";

export const createIntegration = (data, dispatch) => {
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  const orgId = data?.organisationId;
  if (!orgId) {
    toastr.error("Error", "organisationId is required");
    return;
  }
  // dispatch({
  //   type: FETCH_INTEGRATION,
  //   payload: null,
  // });
  axios
    .post(`${API_URL}/createIntegration/${orgId}`, data)
    .then((response) => {
      // window.location.href = '/customers'
      if (response.data.error) toastr.error("Error", response.data.userMessage);
      else {
        toastr.success("Success", response.data.userMessage);
      }
      // if (!response.data.error){
      //   dispatch({
      //     type: FETCH_INTEGRATION,
      //     payload: response.data.data,
      //   });
      // }
      getIntegration(orgId, dispatch)
    })
    .catch((err) => {
      var message = "Some server error has occurred.";
      if (err.response) {
        message = err.response.data.userMessage;
      }

      dispatch({
        type: FETCH_INTEGRATION,
        payload: { error: true, userMessage: message },
      });
    });
};

export const createAlert = (id,data,dispatch) => {
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  axios
    .post(`${API_URL}/organisations/${id}/scan-completion-alert-config` ,data)
    .then((response) => {
      if (response.data.error) toastr.error("Error", response.data.userMessage);
      else {
        getAlert(id,dispatch)
        toastr.success("Success", response.data.userMessage);
      }
    })
    .catch((err) => {
      var message = "Some server error has occurred.";
      if (err.response) {
        message = err.response.data.userMessage;
      }
    });
};

export const getAlert = (id, dispatch) => {
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  axios
    .get(`${API_URL}/organisations/${id}/scan-completion-alert-config`)
    .then((response) => {
      dispatch({
        type: ALERT_INTEGRATION,
        payload: response.data,
      });
    })
    .catch((err) => {
      var message = "Some server error has occurred.";
      if (err.response) {
        message = err.response.data.userMessage;
      }
    });
};

export const createIntegrationjira = (data,dispatch) => {
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  const orgId = data?.organisationId;
  if (!orgId) {
    toastr.error("Error", "organisationId is required");
    return;
  }
  // dispatch({
  //   type: FETCH_INTEGRATION,
  //   payload: null,
  // });
  axios
    .post(`${API_URL}/createIntegration/${orgId}`, data )
    .then((response) => {
      // window.location.href = '/customers'
      if (response.data.error){
        toastr.error("Error", response.data.userMessage);
      }
      else 
      {
        toastr.success("Success", response.data.userMessage);
      }
      getIntegration(orgId , dispatch)
    })
    .catch((err) => {
      var message = "Some server error has occurred.";
      if (err.response) {
        message = err.response.data.userMessage;
      }

      dispatch({
        type: FETCH_INTEGRATION,
        payload: { error: true, userMessage: message },
      });
    });
};

export const getIntegration = (props, dispatch) => {
  if (props) {
    const session = localStorage.getItem("session");
    axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
    dispatch({
      type: FETCH_INTEGRATION,
      payload: null,
    });
    axios
      .get(`${API_URL}/getAllIntegration/${props}`, {})
      .then((response) => {
        dispatch({
          type: FETCH_INTEGRATION,
          payload: response.data.data,
        });
      })
      .catch((err) => {
        var message = "Some server error has occurred.";
        if (err.response) {
          message = err.response.data.userMessage;
        }

        dispatch({
          type: FETCH_INTEGRATION,
          payload: { error: true, userMessage: message },
        });
      });
  }
};

export const updateIntegrationById = (props, dispatch) => {
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;

  const orgId = props?.organisationId;
  if (!orgId) {
    toastr.error("Error", "organisationId is required");
    return;
  }

  axios.patch(`${API_URL}/createIntegration/${orgId}`, { ...props }).then((response) => {
    if (!response.data.error) {
      // dispatch({
      //   type: FETCH_INTEGRATION,
      //   payload: response.data.data,
      // });
      toastr.success("Success", response.data.userMessage);
    } else {
      toastr.error("Error", response.data.userMessage);
    }
    getIntegration(orgId, dispatch)
  });
};

export const updateIntegrationByJira = (data, dispatch, orgId) => {
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;

  const organisationId = data?.organisationId || orgId;
  if (!organisationId) {
    toastr.error("Error", "organisationId is required");
    return;
  }

  axios.patch(`${API_URL}/createIntegration/${organisationId}`, data).then((response) => {
    if (!response.data.error) {
      // dispatch({
      //   type: FETCH_INTEGRATION,
      //   payload: response.data.data,
      // });
      toastr.success("Success", response.data.userMessage);
    } else {
      toastr.error("Error", response.data.userMessage);
    }
    getIntegration(organisationId, dispatch)
  });
};

export const deleteIntegration = (props, dispatch, orgId) => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  // dispatch({
  //   type: FETCH_INTEGRATION,
  //   payload: null,
  // });
  axios
    .delete(`${API_URL}/integration/${props}`, {})
    .then((response) => {
      toastr.success("Success", response.data.userMessage);
      dispatch({
        type: FETCH_INTEGRATION,
        payload: response.data.data,
      });
      
      getIntegration(orgId,dispatch)
    })
    .catch((err) => {
      var message = "Some server error has occurred.";
      if (err.response) {
        message = err.response.data.userMessage;
      }

      dispatch({
        type: FETCH_INTEGRATION,
        payload: { error: true, userMessage: message },
      });
    });
};

export const fetchAlerts = (props, dispatch) => {
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  dispatch({
    type: FETCHING_ALERTS,
    payload: null,
  });
  axios.get(`${API_URL}/security/alerts?organisationId=${props.organisationId}`, { }).then((response) => {
    if (!response.data.error) {
      dispatch({
        type: ALERTS_FETCHED,
        payload: response.data.data,
      });
      // toastr.success("Success", response.data.userMessage);
    } else {
      // toastr.error("Error", response.data.userMessage);
    }
  });
};

export const fetchAlertDetails = (props, dispatch) => {
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  dispatch({
    type: FETCHING_ALERTS,
    payload: null,
  });
  axios.get(`${API_URL}/security/alerts?alertId=${props.alertId}`, { }).then((response) => {
    if (!response.data.error) {
      dispatch({
        type: ALERTS_FETCHED,
        payload: response.data.data,
      });
      toastr.success("Success", response.data.userMessage);
    } else {
      toastr.error("Error", response.data.userMessage);
    }
  });
};



export const fetchProjectList = (props)=>{
  return new Promise((resolve, reject)=>{
    axios.get(`${API_URL}/jira/projects`, { params: props}).then((response) => {
      if (!response.data.error) {
        resolve(response.data);
      } else {
        toastr.error("Error", response.data.userMessage);
        reject();
      }
    }).catch(err=>{
      toastr.error("Error", err);
      reject();
    })
  })
 
}

export const fetchJiraIssueTypes = (props)=>{
  return new Promise((resolve, reject)=>{
    axios.get(`${API_URL}/jira/issues`, { params: props}).then((response) => {
      if (!response.data.error) {
        resolve(response.data);
      } else {
        toastr.error("Error", response.data.userMessage);
        reject();
      }
    }).catch(err=>{
      toastr.error("Error", err);
      reject();
    })
  })
 
}